export default [
  {
    path: '',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          title: '欢迎页'
        }
      },
      {
        path: 'changePwd',
        name: 'changePwd',
        component: () => import('@/views/change-pwd/index.vue'),
        meta: {
            title: '修改密码'
        }
    }
    ]
  }
];
